import { render, staticRenderFns } from "./AplicacaoModal.vue?vue&type=template&id=2905eb72&"
import script from "./AplicacaoModal.vue?vue&type=script&lang=js&"
export * from "./AplicacaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports